<div class="flex justify-center items-center pb-4">
    <img class="rounded-md object-contain object-center max-w-[80%] h-auto" [src]="logo" [alt]="altText" id="logo"
        draggable="false">
</div>
